import { useContext } from 'react';
import { TableModalFormContext } from './SubFormProvider';

/**
 * This hook will detect if the form is rendered inside another form.
 * @returns {boolean} isInsideModal If the form is rendered in another form inside the main form, mostly used for a modal.
 */
const useIsInsideModal = (): boolean => {
  const { isInsideModal } = useContext(TableModalFormContext) || {};
  return isInsideModal || false;
};

export default useIsInsideModal;
